<template>
    <div v-if="data_api">
        <div class="title_cover">
            <h3 v-if="display == 'show'">{{data_api.name}}</h3>
        </div>
        <div class="form-page">
            
            <v-progress-linear v-if="totalPage>0" rounded class="white mb-10 mt-5" color="amber" height="15" :value="currentPage/totalPage*100"></v-progress-linear>

            <v-form v-model="valid">
                <div v-for="(f,i) in data_api.form" :key="i">

                    <div v-if="f.index == currentPage">
                        <!-- Input Text -->
                        <v-text-field v-if="f.type=='text'" v-model="profiling[f.input_name]" maxlength="500" :rules="profilingRules(f)" :label="f.label" clearable clear-icon="mdi-close-circle"></v-text-field>

                        <!-- Textarea -->
                        <v-textarea auto-grow v-if="f.type=='textarea'" v-model="profiling[f.input_name]" maxlength="500" :rules="profilingRules(f)" :label="f.label" clearable clear-icon="mdi-close-circle"></v-textarea>

                        <!-- Dropdown -->
                        <v-select v-if="f.type=='select'" :items="profilingItems(f)" v-model="profiling[f.input_name]" :rules="profilingRules(f)" :label="f.label" @change="checkValidate"></v-select>

                        <!-- radio -->
                        <div v-if="f.validasi && f.validasi.includes('gender') && f.value && f.type=='radio'">
                            <v-row no-gutters>
                                <v-col cols="6" v-for="(g,ig) in f.value" :key="ig">
                                    <div class="item_gender">
                                        <div class="box_gender">
                                            <input type="radio" name="gender" :rules="[(v) => !!v || 'Item is required']" :value="replaceGender(g.key)" v-model="profiling[f.input_name]" :checked="profiling[f.input_name]==replaceGender(g.key)" @change="setGender(replaceGender(g.key), f.input_name)"/>
                                            <span>
                                                <img class="gender_icon" :src="require('@/assets/images/icon_'+replaceGender(g.key)+'.png')" />
                                                <div class="label_gender_icon">{{g.value}}</div>
                                            </span>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                        
                        </div>
                        <div v-else>
                            <v-radio-group v-if="f.type=='radio'" :label="f.label" v-model="profiling[f.input_name]" :rules="profilingRules(f)" >
                                <v-radio v-for="c in f.value" :key="c.key" :value="c.key" :label="c.value" />
                            </v-radio-group>
                        </div>

                        <!-- checkbox -->
                        <v-radio-group v-if="f.type=='checkbox'" :label="f.label" v-model="profiling[f.input_name]" :rules="profilingRules(f)">
                            <v-checkbox v-for="c in f.value" :key="c.key" :value="c.key" :label="c.value" v-model="profiling[f.input_name]" multiple hide-details />
                        </v-radio-group>

                        <!-- Date picker -->
                        <v-dialog  v-if="f.type=='datetime'" ref="dialog" v-model="modal" persistent width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="profiling[f.input_name]" :label="f.label" readonly v-bind="attrs" v-on="on" clearable clear-icon="mdi-close-circle"></v-text-field>
                            </template>
                                <v-date-picker
                                    v-model="profiling[f.input_name]"
                                    scrollable
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="modal = false"
                                    >
                                        OK
                                    </v-btn>
                                </v-date-picker>
                        </v-dialog>

                        <!-- city -->
                        <v-autocomplete v-if="f.type=='select_city'" :items="profilingCity(f)" v-model="profiling[f.input_name]" :rules="profilingRules(f)" :label="f.label"></v-autocomplete>

                        <!-- intro -->
                        <p v-if="f.type=='intro'" class="text-left mt-5 mb-5 caption" v-html="f.label"></p>

                        <!-- media -->
                        <div v-if="f.type=='media'">
                            <h4 class="media label mb-4">{{f.label}}</h4>
                            <div class="box_ktp">
                                <span>
                                    <v-img class="ktp_preview" v-if="mediaPreview[f.input_name] || profiling[f.input_name]" :src="mediaPreview[f.input_name]  || profiling[f.input_name]" width="100%"/>
                                    <img v-else class="ktp_preview" src="@/assets/images/preview-ktp.png" />
                                    <div v-if="mediaError.hd" class="error-message">{{mediaError.hd_message}}</div>
                                </span>
                                <div class="text-center loader-media" v-if="$store.state.progressLoading && mediaType == 'hd'">
                                    <v-container fill-height fluid>
                                        <v-row align="center"
                                            justify="center">
                                            <v-col>
                                                <v-progress-circular
                                                :rotate="-90"
                                                :size="100"
                                                :width="15"
                                                :value="$store.state.progressLoading"
                                                color="orange"
                                                >
                                                {{ $store.state.progressLoading }}
                                                </v-progress-circular>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </div>
                            <div class="text-center button_motif mt-4 mb-4">
                                <v-btn text v-if="mediaPreview[f.input_name] || profiling[f.input_name]" class="inputFile"  dark @click="selectFile(f.input_name)" :loading="mediaLoading[f.input_name]">
                                    Ganti Foto
                                </v-btn>
                                
                                <v-btn v-else class="inputFile" color="primary" large rounded dark @click="selectFile(f.input_name)" :loading="mediaLoading[f.input_name]">
                                    <v-icon class="mr-2" color="white">mdi-camera</v-icon> Ambil foto
                                </v-btn>
                                
                            </div>
                            
                            <div style="visibility: hidden;width: 0; height: 0;">
                                <v-text-field v-model="profiling[f.input_name]" :rules="profilingRules(f)"></v-text-field>
                                <input type="file" accept="image/*" :ref="'file-'+f.input_name" @change="initUpload(f.input_name)" />
                            </div>
                        </div>
                         <!-- media sd -->
                         <div v-if="f.type=='media_sd'">
                            <h4 class="media label mb-4">{{f.label}} </h4>
                            <div class="box_ktp">
                                <span>
                                    <v-img class="ktp_preview" v-if="mediaPreview[f.input_name] || profiling[f.input_name]" :src="mediaPreview[f.input_name]  || profiling[f.input_name]" width="100%"/>
                                    <img v-else class="ktp_preview" src="@/assets/images/preview-ktp.png" />
                                    <div v-if="mediaError.sd" class="error-message">{{mediaError.sd_message}}</div>
                                </span>
                                <div class="text-center loader-media" v-if="$store.state.progressLoading && mediaType == 'sd'">
                                    <v-container fill-height fluid>
                                        <v-row align="center"
                                            justify="center">
                                            <v-col>
                                                <v-progress-circular
                                                :rotate="-90"
                                                :size="100"
                                                :width="15"
                                                :value="$store.state.progressLoading"
                                                color="orange"
                                                >
                                                {{ $store.state.progressLoading }}
                                                </v-progress-circular>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </div>
                            <div class="text-center button_motif mt-4 mb-4">
                                <v-btn text v-if="mediaPreview[f.input_name] || profiling[f.input_name]" class="inputFile"  dark @click="selectFile(f.input_name)" :loading="mediaLoading[f.input_name]">
                                    Ganti Foto
                                </v-btn>
                                
                                <v-btn v-else class="inputFile" color="primary" large rounded dark @click="selectFile(f.input_name)" :loading="mediaLoading[f.input_name]">
                                    <v-icon class="mr-2" color="white">mdi-camera</v-icon> Ambil foto
                                </v-btn>
                                
                            </div>
                            
                            <div style="visibility: hidden;width: 0; height: 0;">
                                <v-text-field v-model="profiling[f.input_name]" :rules="profilingRules(f)"></v-text-field>
                                <input type="file" accept="image/*" :ref="'file-'+f.input_name" @change="initUploadSd(f.input_name)" />
                            </div>
                        </div>
                        
                    </div>

                </div>
            </v-form>

            <div class="text-center button_motif mt-4 mb-4" v-if="!isCombine">
                <v-btn v-if="totalPage>0 && currentPage<totalPage" large rounded color="primary" :disabled="!valid"  dark @click="nextProfilingPage"> Lanjut </v-btn>
                
                <div v-else>
                    <v-btn v-if="!isCompleted && totalPage>0" large rounded color="primary" dark @click="prevProfilingPage" :disabled="!valid"> Lanjut </v-btn>
                    <v-btn v-else large rounded color="primary" dark @click="next" :disabled="!valid || isLoading || !isCompleted" :loading="isLoading"> Lanjut </v-btn>
                </div>                
            </div>
            
        </div>
    </div>
</template>

<style scoped>
.loader-media{
    height: 100%;
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    background: #ffffffeb;
    border-radius: 12px;
}
.error-message{
    color: red;
    display: flex;
}
</style>
<script>
import { mapState } from "vuex"
import sha256 from 'crypto-js/sha256'
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'


export default {
  name: "profiling",
  data() {
    return {
      data_api: this.$parent.data.get.profiling,
      prevPage: this.$store.state.layouts.flow[3]!='profiling' ? this.$store.state.layouts.flow[3] : 'intro',
      nextPage: this.$store.state.layouts.flow[3]!='profiling' ? this.$store.state.layouts.flow[3] : 'question',
      modal: false,
      valid: false,
      totalPage: 0,
      currentPage: 0,
      profiling: this.$session.get('temp_profiling') || this.$store.state.data.post.profiling_answer,
      mediaPreview: {},
      mediaType: 'hd',
      mediaError: {
        hd: false,
        hd_message: "",
        sd: false,
        sd_message: "",
      },
      mediaLoading: {},
      isLoading: false,
      isCompleted: false,
      display: 'show',
      types:  this.$store.state.data.profilingCDPFields
    };
  },
  computed: mapState(['isValidAnswer', 'isValidProfiling', 'isCombine']),
  mounted()
  {
      //redirect to combine
      if(JSON.parse(this.$store.state.data.get.display_options).vertical_style=='yes' && this.$route.name!='form')
      {
        this.$router.push({name:'form'})
      }

      if(JSON.parse(this.$store.state.data.get.display_options).use_captcha=='yes')
      {
        Vue.use(VueReCaptcha, { siteKey:  this.$store.state.captcha_key })
        this.recaptcha()
      }
        
      this.$store.state.progressLoading = 0;

      if( !this.data_api ) 
      {
          this.next()
      }
      else
      {
        //if( this.isValidAnswer ) this.next() //auto next

        this.getCookie()

        this.getSso()
        
        this.indexingProfiling()
      }
      
      this.display = JSON.parse(this.$parent.data.get.display_options).ic_title_prof !== undefined ? JSON.parse(this.$parent.data.get.display_options).ic_title_prof : 'show';
    
  },
  created()
  {
      this.viewTracker('profiling');

      this.$parent.updateHead();

      // check last_answered
        var user = this.$store.state.data.userLogin;
        var th = this;
        //console.log(user);
        //check unique
        if( this.$store.state.data?.get?.is_unique && this.$store.state.data?.get?.using_sso && user?.data?.id )
        {        
        this.$store.dispatch('api_post_ic_last_answered', {
            user_id: user.data.id,
            callback: function(res){
                if(res?.data?.status == 'success')
                {
                    //th.$store.state.data.isRunning = false;
                    th.$router.push({name:'unique'});               
                }
            }
        })
        }
  },
  methods: {
      prev()
      {
          return this.$router.push({name:this.prevPage})
      },

      next()
      {
        var th = this

        if( th.data_api )
        {
            th.setCookie()
            th.sendTracker()
            th.sendtoCDP()
            th.sendExternalTracker()
            th.ssoSend(this.types)

            th.isLoading = true

            this.$store.dispatch('api_post_ic', function(res){

                th.isLoading = false
                
                if( res && res.status == 'success' )
                {
                    th.sendtoVidio()
                    
                    //if( th.isValidAnswer || (th.currentPage == 0 && th.totalPage>0 ))
                    //    return th.$router.push({name:'result'})
                    //else
                    //console.log("nextPage: ",th.nextPage);
                    return th.$router.push({name:th.nextPage})
                }
                else th.$toasted.show('Terjadi kesalahan, silakan coba lagi').goAway(1500);
            })
        }
        else th.$router.push({name:th.nextPage})
      },

      profilingItems(f) 
      {
        var items = [];
        if( f.value )
        {
            for( var i in f.value )
            {
                items.push({
                    text: f.value[i].value,
                    value: f.value[i].key
                });
            }
        }
        return items;
    },

    profilingCity(f) {
        var items = [];
        if( f.data )
        {
            for( var i in f.data )
            {
                items.push({
                    text: f.data[i].name,
                    value: f.data[i].id
                });
            }
        }
        return items;
    },

    profilingRules(f)
    {
        var rules = [];

        if( f.validasi )
        {
            for( var i in f.validasi )
            {
                if( f.validasi[i] == 'required' )
                {
                    rules.push(v=>{
                        return !!v || f.label + ' wajib diisi'
                    });
                }

                if( f.validasi[i] == 'url' )
                {
                    rules.push(v=>{
                        var pattern = new RegExp(
                            '^(https?:\\/\\/)?' + 
                            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + 
                            '((\\d{1,3}\\.){3}\\d{1,3}))' + 
                            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                            '(\\?[;&a-z\\d%_.~+=-]*)?' +
                            '(\\#[-a-z\\d_]*)?$',
                            'i'
                        );
                        return pattern.test(v) || 'Format '+ f.label +' salah'
                    });
                }

                if( f.validasi[i] == 'email' )
                {
                    rules.push(v=>{
                        return /.+@.+/.test(v) || 'Format '+ f.label +' salah'
                    });
                }

                if( f.validasi[i] == 'numeric' )
                {
                    rules.push(v=>{
                        return /^\d+$/.test(v) || 'Format '+ f.label +' harus angka'
                    });
                }

                if( f.validasi[i].substring(0, 9) == 'maxlength' )
                {
                    var n = parseInt(f.validasi[i].substring(10, f.validasi[i].length-1));

                    rules.push(v=>{
                        return (v ? v.length : 0)<=n || f.label +' maksimal '+n+' karakter'
                    });
                }

                if( f.validasi[i] == 'yob' )
                {
                    var year = parseInt(new Date().getFullYear());

                    rules.push(v=>{
                        return /^\d+$/.test(v) && v<=year && (year-v)<80 || 'Format '+ f.label +' salah'
                    });
                }

                if( f.validasi[i] == 'phone' )
                {
                    rules.push(v=>{
                        return /^(((0|\+?62)8\d{8,11})|(\+60\d{8,10})|(\+65\d{8})|(\+673\d{8,10})|(\+886\d{5,8})|(\+852\d{3,11}))$/.test(v) || 'Format '+ f.label +' salah'
                    });
                }
            }
        }

        return rules;
    },

    setGender(check, name) 
    {
        this.profiling[name] = check

        this.$set(this.profiling, name, check)

        this.checkValidate()
    },

    setCookie()
    {
        if( this.data_api.form )
        {
            var year_now = new Date().getFullYear();

            for( var i in this.data_api.form )
            {
                var f = this.data_api.form[i];

                if(f.validasi) 
                {
                    for( var j in this.types )
                    {
                        var type = this.types[j]
                        
                        if( f.validasi.includes(type) )
                        {
                            if( this.profiling[f.input_name] )
                            {
                                if( ['email', 'phone'].includes(type) )
                                {
                                    this.$cookies.set('newshub_'+type, sha256(this.profiling[f.input_name]));
                                    this.$cookies.set('newshub_'+type+'_ori', this.profiling[f.input_name]);
                                }
                                else if( ['yob', 'dob'].includes(type) )
                                {
                                    var year = this.profiling[f.input_name];
                                        year = year ? new Date(year).getFullYear() : null;

                                    if( year )
                                    {
                                        this.$cookies.set('newshub_age_yob', year);
                                        this.$cookies.set('newshub_age', year_now - year);
                                    }

                                    if( type=='dob' )
                                    {
                                        this.$cookies.set('newshub_age_datetime', this.profiling[f.input_name]);
                                    }
                                }
                                else if( ['age'].includes(type) )
                                {
                                    //update yob
                                    if( !this.$cookies.get('newshub_age_yob'))
                                    {
                                        this.$cookies.set('newshub_age_yob', (year_now - this.profiling[f.input_name]));
                                    }

                                    this.$cookies.set('newshub_'+type, this.profiling[f.input_name]);
                                }
                                else
                                {
                                    this.$cookies.set('newshub_'+type, this.profiling[f.input_name]);
                                }
                            }
                        }
                    }
                }
            }
        }
    },

    getCookie()
    {
        var value = null;

        var year_now = new Date().getFullYear();
        
        for( var i in this.data_api.form )
        {
            if( this.data_api.form[i].validasi )
            {
                for( var j in this.types )
                {
                    var type = this.types[j];

                    if( this.data_api.form[i].validasi.includes(this.types[j]) )
                    {
                        if( this.data_api.form[i].type=='datetime' )
                        {
                            this.profiling[this.data_api.form[i].input_name] = this.$cookies.get('newshub_age_datetime');
                        }
                        else
                        {
                            if( ['email', 'phone'].includes(type) )
                            {                                
                                value = this.$cookies.get('newshub_'+type+'_ori');

                                if( value ) this.profiling[this.data_api.form[i].input_name] = value
                            }
                            else if( ['yob'].includes(type) )
                            {
                                value = this.$cookies.get('newshub_age_yob');

                                if( value ) this.profiling[this.data_api.form[i].input_name] = value
                            }
                            else if( ['gender'].includes(type) )
                            {
                                value = this.$cookies.get('newshub_gender');

                                if( value && ['male','female'].includes(value)) this.profiling[this.data_api.form[i].input_name] = value
                            }
                            else
                            {
                                value = this.$cookies.get('newshub_'+type);

                                if( value ) this.profiling[this.data_api.form[i].input_name] = value
                            }
                        }

                        // get from liputan6 cookie
                        if( !this.profiling[this.data_api.form[i].input_name] )
                        {
                            if( type == 'gender' && ['male', 'female'].includes(this.$cookies.get('liputan6_id_gender')))
                            {
                                this.profiling[this.data_api.form[i].input_name] = this.$cookies.get('liputan6_id_gender')
                            }
                            else if( type == 'age' )
                            {
                                this.profiling[this.data_api.form[i].input_name] = this.$cookies.get('liputan6_id_age')
                            }
                            else if( type == 'yob' )
                            {
                                if(this.$cookies.get('liputan6_id_age')) this.profiling[this.data_api.form[i].input_name] = year_now - this.$cookies.get('liputan6_id_age')
                            }
                        }
                    }
                }
            }
        }
    },

    getSso()
    {
        var user = this.$store.state.data.userLogin || null;
            user = user ? user.data : null;

        if( user )
        {
            for( var i in user )
            {
                for( var f in this.data_api.form )
                {
                    if( this.data_api.form[f].validasi )
                    {
                        if( this.data_api.form[f].type=='datetime' )
                        {
                            this.profiling[this.data_api.form[f].input_name] = '';
                        }
                        else
                        {
                            if( this.data_api.form[f].validasi.includes(i) && user[i] )
                            {
                                this.profiling[this.data_api.form[f].input_name] = user[i]
                            }
                        }
                    }
                }    
            }
        }
    },

    checkValidate()
    {
        this.isCompleted = true;
        var newProfiling = {};

        if( this.data_api && this.data_api.form )
        {
            for( var f in this.data_api.form )
            {
                if( this.data_api.form[f].validasi.includes('required') )
                {
                    if( this.profiling[this.data_api.form[f].input_name] == null )
                    {
                        this.isCompleted = false
                    }
                    else newProfiling[this.data_api.form[f].input_name] = this.profiling[this.data_api.form[f].input_name]
                }

                //set state
                if( this.profiling[this.data_api.form[f].input_name] )
                {
                    if( this.data_api.form[f].validasi.includes('gender') )
                    {
                        window.kly.visitor.gender = this.profiling[this.data_api.form[f].input_name]
                        window.kly.gtm.gender = this.profiling[this.data_api.form[f].input_name]
                    }
                    if( this.data_api.form[f].validasi.includes('age') )
                    {
                        window.kly.visitor.age = this.profiling[this.data_api.form[f].input_name]
                        window.kly.gtm.age = this.profiling[this.data_api.form[f].input_name]
                    }
                    if( this.data_api.form[f].validasi.includes('yob') )
                    {
                        window.kly.visitor.age = new Date().getFullYear() - this.profiling[this.data_api.form[f].input_name]
                        window.kly.gtm.age = new Date().getFullYear() - this.profiling[this.data_api.form[f].input_name]
                    }
                    if( this.data_api.form[f].validasi.includes('email') )
                    {
                        window.kly.gtm.email_sha256 = sha256(this.profiling[this.data_api.form[f].input_name])
                    }
                    if( this.data_api.form[f].validasi.includes('phone') )
                    {
                        window.kly.gtm.phone_sha256 = sha256(this.profiling[this.data_api.form[f].input_name])
                    }
                }
            }
        }
    },

    indexingProfiling()
    {
        if( this.data_api.form )
        {
            var i = 0;
            for( var f in this.data_api.form )
            {
                this.data_api.form[f].index = i

                if( this.data_api.form[f].type == 'pagebreak' ) i++
            }
            this.totalPage = i;
            
            document.dispatchEvent(new CustomEvent("page:profiling", {
                detail: {
                    current: this.currentPage,
                    total: this.totalPage
                }
            }));
        }
    },
    prevProfilingPage()
    {
        if(this.currentPage>0) this.currentPage--

        this.viewTracker('profiling - '+(this.currentPage+1));
        
        document.dispatchEvent(new CustomEvent("page:profiling", {
            detail: {
                current: this.currentPage,
                total: this.totalPage
            }
        }));
        
    },
    nextProfilingPage()
    {
        this.currentPage++

        this.viewTracker('profiling - '+(this.currentPage+1));
        
        document.dispatchEvent(new CustomEvent("page:profiling", {
            detail: {
                current: this.currentPage,
                total: this.totalPage
            }
        }));
    },
    selectFile(id)
    {
        if( this.$refs['file-'+id][0] )
        {
            this.$refs['file-'+id][0].click()
        }
    },
    initUpload(id)
    {
        this.mediaError.hd=false
        this.mediaError.hd_message=''
        //read image
        var file = this.$refs['file-'+id][0].files[0];

        if( file )
        {
            if( file.size/1024/1024>5 )
            {
                this.$toasted.show('Ukuran file harus di bawah 5MB!').goAway(1500);
                this.$refs['file-' + id][0].value=null
                this.mediaError.hd=true
                this.mediaError.hd_message='Ukuran file harus di bawah 5MB!'
                return false
            }
            if(!(file.type=="image/jpeg" || file.type=="image/png" || file.type=="image/jpg") )
            {
                this.$toasted.show('Tipe file harus jpeg/jpg atau png!').goAway(1500);
                this.$refs['file-' + id][0].value=null
                this.mediaError.hd=true
                this.mediaError.hd_message='Tipe file harus jpeg/jpg atau png!'
                return false
            }
            
            var url = URL.createObjectURL(file);

            this.$set(this.mediaLoading, id, true)
            this.$set(this.mediaPreview, id, url)
            this.$set(this.profiling, id, false)
            var th = this

            var reader = new FileReader();
                reader.onload = function(e) {
                    var blob = new Blob([new Uint8Array(e.target.result)], {type: file.type });
                    
                    var fd = new FormData()
                    fd.append('file_upload', blob, 'filename.jpg')
                    th.mediaType = 'hd'
                    th.$store.dispatch("app_upload_image", fd)
                    .then(data => {
                        if( data )
                        {
                            th.$set(th.profiling, id, data.file)
                            th.$set(th.mediaPreview, id, data.file)
                            th.$set(th.mediaLoading, id, false)
                            th.$store.state.progressLoading = 0;
                        }else{
                            th.$store.state.progressLoading = 0;
                            th.$set(th.mediaPreview, id,null)
                            th.$set(th.mediaLoading, id, false)
                        }
                    })
                };
                reader.readAsArrayBuffer(file);
        }

    },
    initUploadSd(id) {
        var th = this
        this.mediaError.sd=false
        this.mediaError.sd_message=''
        //read image
        var file = this.$refs['file-' + id][0].files[0];
        if(!(file.type=="image/jpeg" || file.type=="image/png" || file.type=="image/jpg") )
        {
            this.$toasted.show('Tipe file harus jpeg/jpg atau png!').goAway(1500);
            this.$refs['file-' + id][0].value=null
            this.mediaError.sd=true
            this.mediaError.sd_message='Tipe file harus jpeg/jpg atau png!'
            return false
        }
        
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
            th.resizeCanvas(e.target.result, function (canvas) {
                var typecanvas = "image/jpeg";
                canvas.toBlob(function (blob) {
                    const reader = new FileReader();
                    
                    reader.onload = function(event) {
                        th.$set(th.mediaLoading, id, true)
                        th.$set(th.mediaPreview, id, event.target.result)
                        th.$set(th.profiling, id, false)

                        var fd = new FormData()
                        fd.append('base64', event.target.result)
                        th.mediaType = 'sd'

                        th.$store.dispatch("app_upload_image", fd)
                            .then(data => {
                                if (data) {
                                    th.$set(th.profiling, id, data.file)
                                    th.$set(th.mediaPreview, id, data.file)
                                    th.$set(th.mediaLoading, id, false)
                                    th.$store.state.progressLoading = 0;
                                }else{
                                    th.$store.state.progressLoading = 0;
                                    th.$set(th.mediaPreview, id,null)
                                    th.$set(th.mediaLoading, id, false)
                                }
                            }
                        )
                    };
                    reader.readAsDataURL(blob);
                }, typecanvas, 0.8)
            });
        };

        fileReader.readAsDataURL(file);
    },
    resizeCanvas(url, callback) {
        var img = new Image();
        img.onload = function () {
            var oc = document.createElement('canvas'), octx = oc.getContext('2d');
            oc.width = img.width;
            oc.height = img.height;
            octx.drawImage(img, 0, 0);
            if (img.width > 1200) {
                while (oc.width * 0.8 > 1200) {
                    oc.width *= 0.8;
                    oc.height *= 0.8;
                    octx.drawImage(oc, 0, 0, oc.width, oc.height);
                }
                oc.height = oc.width * img.height / img.width;
                octx.drawImage(img, 0, 0, oc.width, oc.height);
            }
            return callback(oc);
        };
        img.src = url;
    },
    async recaptcha() {
        if(JSON.parse(this.$store.state.data.get.display_options).use_captcha=='yes'){
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha('submit')
            this.$store.state.data.post.captcha_token = token
        }
    },

  },
  watch: {
    profiling: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$store.commit('set_post_profiling', val);

        this.$session.set('temp_profiling',val);

        this.checkValidate();

        if( this.isCombine )
        {
            this.$store.commit('set_is_valid_combine', (this.isValidAnswer && this.isValidProfiling) ? false : true );
        }
      }
    },
    valid: {
      immediate: true,
      deep: true,
      handler(val) {
        
        this.checkValidate();

        this.$store.commit('set_isvalid_profiling', val);

        if( this.isCombine )
        {
            this.$store.commit('set_is_valid_combine', (this.isValidAnswer && val) ? false : true );
        }

      }
    }
  }
};
</script>
